import { ActionType, createAction } from 'typesafe-actions'
import {
  IChifamDetailsReq,
  IChifamDetailsRes,
  IChifamHoldingDetail,
  IChifamHoldingsDetailReq,
  IChifamHoldingsSummaryReq,
  IHoldings,
  IChifamAccountsReq,
  IChifamAccountsRes
} from '../api/types'

export const FETCH_CHIFAM_DETAILS_REQUEST = `@modules/@chifamData/FETCH_CHIFAM_DETAILS_REQUEST`
export const FETCH_CHIFAM_DETAILS_SUCCESS = `@modules/@chifamData/FETCH_CHIFAM_DETAILS_SUCCESS`
export const FETCH_CHIFAM_DETAILS_FAILURE = `@modules/@chifamData/FETCH_CHIFAM_DETAILS_FAILURE`
export const FETCH_CHIFAM_DETAILS_CLEAR = `@modules/@chifamData/FETCH_CHIFAM_DETAILS_CLEAR`

export const fetchChifamDetailsActions = {
  request: createAction(FETCH_CHIFAM_DETAILS_REQUEST)<IChifamDetailsReq>(),
  success: createAction(FETCH_CHIFAM_DETAILS_SUCCESS)<IChifamDetailsRes>(),
  failure: createAction(FETCH_CHIFAM_DETAILS_FAILURE)<Error>(),
  clear: createAction(FETCH_CHIFAM_DETAILS_CLEAR)()
}

export const FETCH_CHIFAM_HOLDING_DETAILS_REQUEST = `@modules/@chifamData/FETCH_CHIFAM_HOLDING_DETAILS_REQUEST`
export const FETCH_CHIFAM_HOLDING_DETAILS_SUCCESS = `@modules/@chifamData/FETCH_CHIFAM_HOLDING_DETAILS_SUCCESS`
export const FETCH_CHIFAM_HOLDING_DETAILS_FAILURE = `@modules/@chifamData/FETCH_CHIFAM_HOLDING_DETAILS_FAILURE`
export const FETCH_CHIFAM_HOLDING_DETAILS_CLEAR = `@modules/@chifamData/FETCH_CHIFAM_HOLDING_DETAILS_CLEAR`

export const fetchChifamHoldingDetailsActions = {
  request: createAction(
    FETCH_CHIFAM_HOLDING_DETAILS_REQUEST
  )<IChifamHoldingsDetailReq>(),
  success: createAction(FETCH_CHIFAM_HOLDING_DETAILS_SUCCESS)<IHoldings>(),
  failure: createAction(FETCH_CHIFAM_HOLDING_DETAILS_FAILURE)<Error>(),
  clear: createAction(FETCH_CHIFAM_HOLDING_DETAILS_CLEAR)()
}

export const FETCH_CHIFAM_HOLDING_SUMMARY_REQUEST = `@modules/@chifamData/FETCH_CHIFAM_HOLDING_SUMMARY_REQUEST`
export const FETCH_CHIFAM_HOLDING_SUMMARY_SUCCESS = `@modules/@chifamData/FETCH_CHIFAM_HOLDING_SUMMARY_SUCCESS`
export const FETCH_CHIFAM_HOLDING_SUMMARY_FAILURE = `@modules/@chifamData/FETCH_CHIFAM_HOLDING_SUMMARY_FAILURE`
export const FETCH_CHIFAM_HOLDING_SUMMARY_CLEAR = `@modules/@chifamData/FETCH_CHIFAM_HOLDING_SUMMARY_CLEAR`

export const fetchChifamHoldingSummaryActions = {
  request: createAction(
    FETCH_CHIFAM_HOLDING_SUMMARY_REQUEST
  )<IChifamHoldingsSummaryReq>(),
  success: createAction(FETCH_CHIFAM_HOLDING_SUMMARY_SUCCESS)<
    IChifamHoldingDetail[]
  >(),
  failure: createAction(FETCH_CHIFAM_HOLDING_SUMMARY_FAILURE)<Error>(),
  clear: createAction(FETCH_CHIFAM_HOLDING_SUMMARY_CLEAR)()
}

export const FETCH_ACCOUNTS_REQUEST = `@modules/@chifamData/FETCH_ACCOUNTS_REQUEST`
export const FETCH_ACCOUNTS_SUCCESS = `@modules/@chifamData/FETCH_ACCOUNTS_SUCCESS`
export const FETCH_ACCOUNTS_FAILURE = `@modules/@chifamData/FETCH_ACCOUNTS_FAILURE`
export const FETCH_ACCOUNTS_CLEAR = `@modules/@chifamData/FETCH_ACCOUNTS_CLEAR`

export const fetchAccountsActions = {
  request: createAction(FETCH_ACCOUNTS_REQUEST)<any>(),
  success: createAction(FETCH_ACCOUNTS_SUCCESS)<any>(),
  failure: createAction(FETCH_ACCOUNTS_FAILURE)<Error>(),
  clear: createAction(FETCH_ACCOUNTS_CLEAR)()
}

export const INSERT_UPDATE_REALLOCATION_REQUEST = `@modules/@chifamData/INSERT_UPDATE_REALLOCATION_REQUEST`
export const INSERT_UPDATE_REALLOCATION_SUCCESS = `@modules/@chifamData/INSERT_UPDATE_REALLOCATION_SUCCESS`
export const INSERT_UPDATE_REALLOCATION_FAILURE = `@modules/@chifamData/INSERT_UPDATE_REALLOCATION_FAILURE`
export const INSERT_UPDATE_REALLOCATION_CLEAR = `@modules/@chifamData/INSERT_UPDATE_REALLOCATION_CLEAR`

export const insertUpdateReallocationActions = {
  request: createAction(INSERT_UPDATE_REALLOCATION_REQUEST)<IHoldings>(),
  success: createAction(INSERT_UPDATE_REALLOCATION_SUCCESS)<any>(),
  failure: createAction(INSERT_UPDATE_REALLOCATION_FAILURE)<Error>(),
  clear: createAction(INSERT_UPDATE_REALLOCATION_CLEAR)()
}

export const GENERATE_DOCUMENT_REQUEST = `@modules/@chifamData/GENERATE_DOCUMENT_REQUEST`
export const GENERATE_DOCUMENT_SUCCESS = `@modules/@chifamData/GENERATE_DOCUMENT_SUCCESS`
export const GENERATE_DOCUMENT_FAILURE = `@modules/@chifamData/GENERATE_DOCUMENT_FAILURE`
export const GENERATE_DOCUMENT_CLEAR = `@modules/@chifamData/GENERATE_DOCUMENT_CLEAR`

export const generateDocumentActions = {
  request: createAction(GENERATE_DOCUMENT_REQUEST)<{
    documentType: string
    holdingDate: string
  }>(),
  success: createAction(GENERATE_DOCUMENT_SUCCESS)<Blob>(),
  failure: createAction(GENERATE_DOCUMENT_FAILURE)<Error>(),
  clear: createAction(GENERATE_DOCUMENT_CLEAR)()
}

export const FETCH_CHIFAM_ACCOUNTS_REQUEST = `@modules/@chifamData/FETCH_CHIFAM_ACCOUNTS_REQUEST`
export const FETCH_CHIFAM_ACCOUNTS_SUCCESS = `@modules/@chifamData/FETCH_CHIFAM_ACCOUNTS_SUCCESS`
export const FETCH_CHIFAM_ACCOUNTS_FAILURE = `@modules/@chifamData/FETCH_CHIFAM_ACCOUNTS_FAILURE`
export const FETCH_CHIFAM_ACCOUNTS_CLEAR = `@modules/@chifamData/FETCH_CHIFAM_ACCOUNTS_CLEAR`

export const fetchChifamAccountsActions = {
  request: createAction(FETCH_CHIFAM_ACCOUNTS_REQUEST)<IChifamAccountsReq>(),
  success: createAction(FETCH_CHIFAM_ACCOUNTS_SUCCESS)<IChifamAccountsRes>(),
  failure: createAction(FETCH_CHIFAM_ACCOUNTS_FAILURE)<Error>(),
  clear: createAction(FETCH_CHIFAM_ACCOUNTS_CLEAR)()
}

export type fetchChifamDetailsActionsType = ActionType<
  typeof fetchChifamDetailsActions
>
export type fetchChifamHoldingDetailsActionsType = ActionType<
  typeof fetchChifamHoldingDetailsActions
>
export type fetchChifamHoldingSummaryActionsType = ActionType<
  typeof fetchChifamHoldingSummaryActions
>
export type fetchAccountsActionsType = ActionType<typeof fetchAccountsActions>
export type insertUpdateReallocationActionsType = ActionType<
  typeof insertUpdateReallocationActions
>
export type generateDocumentActionsType = ActionType<
  typeof generateDocumentActions
>
export type fetchChifamAccountsActionsType = ActionType<
  typeof fetchChifamAccountsActions
>

export type ChifamActionsTypes =
  | fetchChifamDetailsActionsType
  | fetchChifamHoldingDetailsActionsType
  | fetchChifamHoldingSummaryActionsType
  | fetchAccountsActionsType
  | insertUpdateReallocationActionsType
  | generateDocumentActionsType
  | fetchChifamAccountsActionsType
